import "./icons.css";
import "./icons_extra.css";
export default function () {
  // This plugin just requires icons import
}
